import { useMemo } from "react";
import { TransactionView } from "@common/types/views/transactionViews";
import { NamedView } from "@common/types/views/views";
import { DEFAULT_VIEW_ID } from "@components/views/constants";
import { useBuiltInTransactionViews } from "./BuiltInTransactionViews";
import { TRANSFER_REVIEW_VIEW_ID } from "./TransferReviewView";

export function useTransactionsPageDefaultViewId(): string {
    const isMatchReviewDefault = false;
    // Temporary disabled, since i was told to revert but not to revert
    // assignment?.organizationId != null ||
    // assignment?.role === UserWorkspaceRole.ACCOUNTANT ;

    return isMatchReviewDefault ? TRANSFER_REVIEW_VIEW_ID : DEFAULT_VIEW_ID;
}

export function useTransactionsPageDefaultView():
    | NamedView<TransactionView>
    | undefined {
    const builtInViews = useBuiltInTransactionViews();
    const defaultViewId = useTransactionsPageDefaultViewId();

    return useMemo(
        () => builtInViews.find((view) => view.id === defaultViewId),
        [builtInViews, defaultViewId],
    );
}
